module.exports = __webpack_public_path__ + "img/page15.aaf1c030.gif";